module.exports = __webpack_public_path__ + "img/2.0259958c.png";